import { isMockMode, post, simulateDelay } from "../api";

export const createMachineLockedSub = (data) => {
	if (isMockMode()) {
		const testData = { isValid: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/CreateMachineLockedSub`, data, {
		successMessage: "Subscription successfully created",
	});
};
